import ".././styles/Events.css";
import EventCard from ".././components/EventCard";
import pccmlogo from ".././assets/pccm_logo.png";
import React, { useState, useEffect, useLayoutEffect } from 'react';

// --- Configuration for Google Sheets API ---
const GOOGLE_API_KEY = 'AIzaSyCLfnoX4kMuKDpNMQ9HZ2qJP28aRKNd2Hg';
const SPREADSHEET_ID = '16I9JOyUgHldKvU8AqhPl8ABxFRwBfb_mk37zbMhU1mU';
const SHEET_RANGE = 'programsAndServices!A:E';

function Events() {
    const [programs, setPrograms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                const googleSheetsApiUrl = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${SHEET_RANGE}?key=${GOOGLE_API_KEY}`;

                const response = await fetch(googleSheetsApiUrl);

                if (!response.ok) {
                    const errorJson = await response.json(); // Google API returns error as JSON
                    const errorMessage = errorJson.error ? errorJson.error.message : response.statusText;
                    throw new Error(`HTTP Error! Status: ${response.status} - ${errorMessage}`);
                }

                const jsonData = await response.json();
                console.log(jsonData);

                if (jsonData && jsonData.values) {
                    // The first row of the sheet is the headers
                    const headers = jsonData.values[0];
                    const rows = jsonData.values.slice(1);

                    const parsedPrograms = rows.map(row => {
                        let program = {};
                        headers.forEach((header, index) => {
                            program[header.toLowerCase()] = row[index];
                        });
                        return program;
                    });
                    setPrograms(parsedPrograms);
                } else {
                    console.warn("Google Sheets API data not found or response is empty.", jsonData);
                    setPrograms([]);
                }
            } catch (err) {
                console.error("Error fetching programs and services:", err);
                setError(err);
                setPrograms([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []); // Runs only once on mount

    // Only scroll when loading is false and no error occurred
    useLayoutEffect(() => {
        if (!loading && !error) {
            window.scrollTo(0, 0);
        }
    }, [loading, error]);

    if (loading) {
        return (
            <div className="loading">
                <img src={pccmlogo} className="sml-logo" alt="pccm-logo"></img>
                <p><b>Loading Events & Services page...</b></p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="loading">
                <h1>⚠︎</h1>
                <p className="loading"><b>Error: {error.message}</b></p>
                <div className="button-2" onClick={() => window.location.reload()}>Retry</div>
            </div>
        );
    }

    return (
        <div className="events-page">
            <div className="container">
                <div className="events-banner-container" id="banner">
                    <div className="events-banner">
                        <h1>Events & Services</h1>
                    </div>
                </div>
            </div>
            <div id="events"></div>
            <div className="section upcoming-events-container">
                <h2 className="section-title">Upcoming Events & Reminders</h2>
                <div className="upcoming-events">
                    {/* The Tockify script is loaded in tne index.html head*/}
                    <div data-tockify-component="calendar" data-tockify-calendar="thepccm"
                    data-tockify-width="100%" data-tockify-height="80%"></div>
                </div>
            </div>
            <div id="programs-and-services"></div>
            <div className="section programs-container">
                <h2 className="section-title">Programs & Services</h2>
                <p id="programs-summary">
                    The PCCM offers programs and services that cater to the Filipino community, newly arrived immigrants,
                    and the surrounding areas in Winnipeg and Manitoba. These initiatives aim to promote cultural identity and
                    community pride while enriching Filipino-Canadian heritage. The programs facilitate cultural, social, and
                    educational activities for the Filipino community and its neighbors in Winnipeg and Manitoba.
                </p>
                <div className="programs-list">
                    {/* Map over the fetched programs data to render EventCard components */}
                    {programs.length > 0 ? (
                        programs.map((program, index) => {
                            return (
                                <EventCard
                                    key={program.id || program.title || program.name || index} // Use unique ID if available from sheet
                                    image={program.image}
                                    title={program.title}
                                    description={program.description}
                                    link={program.link}
                                />
                            );
                        })
                    ) : (
                        <p>No programs found.</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Events;